import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Credit Coins',
				id: 'creditCoins',
				isEnabled: (rowData: any) => {
					const { creditedAt, creditedBy, state } = rowData;
					if ((creditedAt || creditedBy) && (state === 'PROCESSING' || state === 'SUCCESS')) {
						return false;
					}

					return hasPermission({
						entity: DASHBOARD_RESOURCES.wallet,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.wallet]?.addCoinsFromCsv,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.wallet,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.wallet]?.addCsvDetails,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
